export const COLLAPSIBLE_TAG_NAME = "collapsible" as const;

export const COLLAPSIBLE_TRIGGER_TAG_NAME = "collapsible-trigger" as const;

export const COLLAPSIBLE_CONTENT_TAG_NAME = "collapsible-content" as const;
